import DTimePicker from './src';

DTimePicker.install = Vue => {
  Vue.component('DTimePicker', DTimePicker);
};

export default DTimePicker;
